import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import c from 'classnames';

import { Button } from '../../../components';

const FooterMenu = () => {
  const classNames = c('FooterMenu');

  return (
    <div className={classNames}>
      <Menu id="footer">
        {(items) => {
          return (
            <ul className="FooterMenu__items">
              {items.map((item) => {
                const href = item.getIn(['link', 'url'], '');
                const title = item.getIn(['link', 'title'], 'Untitled');
                return (
                  <Button secondary white key={href} href={href}>{title}</Button>
                );
              })}
            </ul>
          );
        }}
      </Menu>
    </div>
  );
};

export default FooterMenu;
